import styled from 'styled-components';

import { media } from '@/utils';

export const FilterBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 15px;
  background: ${({ theme }) => theme.colors.card.background};
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  border-radius: 6px 6px 0 0;
  margin: 20px 0 0 0;
  gap: 20px;
  box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? '0 1px 3px rgba(255, 255, 255, 0.03)'
    : '0 1px 3px rgba(224, 123, 45, 0.06)')};

  @media (max-width: 1200px) {
    flex-wrap: wrap;
  }

  ${media.mobile} {
    flex-direction: row;
    align-items: center;
    padding: 12px;
    gap: 10px;
  }
`;

export const FilterBarSection = styled.div<{ $position?: 'left' | 'right' }>`
  display: flex;
  align-items: center;
  gap: 12px;

  ${(props) => props.$position === 'left' && `
    flex: 1;
    min-width: 0;
  `}

  ${(props) => props.$position === 'right' && `
    white-space: nowrap;
  `}

  ${media.mobile} {
    gap: 8px;

    ${(props) => props.$position === 'left' && `
      flex: 1;
      min-width: 0;
    `}

    ${(props) => props.$position === 'right' && `
      flex-shrink: 0;
    `}
  }
`;

export const FilterLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.secondary};
  white-space: nowrap;

  ${media.mobile} {
    display: none;
  }
`;

export const ItemsPerPageWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  ${media.mobile} {
    display: none;
  }
`;

export const SearchInputWrapper = styled.div`
  flex: 1;
  min-width: 0;
  max-width: 340px;
 

  ${media.mobile} {
    max-width: 100%;
    flex: 1;

    input {
      font-size: 14px;
   
    }

    /* Make input smaller on mobile */
    .group {
      width: 100%;
    }
  }
`;

export const ViewModeToggle = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#f3f4f6')};
  border-radius: 6px;
  padding: 4px;
  gap: 4px;
`;

export const ViewModeButton = styled.button<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 6px;
  background: ${(props) => {
    if (props.$isActive) return props.theme.colors.card.background;
    return 'transparent';
  }};
  color: ${(props) => {
    if (props.$isActive) return props.theme.colors.text.primary;
    return props.theme.colors.text.secondary;
  }};
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: ${(props) => (props.$isActive ? '0 1px 3px rgba(0, 0, 0, 0.1)' : 'none')};

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
    background: ${(props) => {
    if (props.$isActive) return props.theme.colors.card.background;
    return props.theme.mode === 'dark' ? '#4b5563' : '#e5e7eb';
  }};
  }

  &:active {
    transform: scale(0.95);
  }
`;
